export default "__VITE_ASSET__B1ZRCa20__";